webpackJsonp([220445717415976],{

/***/ 104:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 212:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(52);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	__webpack_require__(104);
	
	__webpack_require__(105);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Docs = function Docs() {
	  if (("production") === "production" && global.window) {
	    throw new Error("Docs can't be rendered in browser");
	  }
	  return _react2.default.createElement(
	    "div",
	    { className: "container docs-container" },
	    _react2.default.createElement(
	      "div",
	      { className: "docs-side-nav" },
	      _react2.default.createElement(
	        "div",
	        {
	          className: "sphinxsidebar",
	          role: "navigation",
	          "aria-label": "main navigation"
	        },
	        _react2.default.createElement(
	          "div",
	          { className: "sphinxsidebarwrapper" },
	          _react2.default.createElement(
	            "h3",
	            { className: "callout" },
	            _react2.default.createElement(
	              "a",
	              { href: "{{ pathto(master_doc) }}" },
	              "Table Of Contents"
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "sphinxsidebarwrapperlinks" },
	            "{{ toctree() }}"
	          ),
	          _react2.default.createElement(
	            "a",
	            { href: "https://readthedocs.org/projects/graphene-python/versions/" },
	            "Older versions"
	          )
	        )
	      ),
	      " "
	    ),
	    _react2.default.createElement(
	      "div",
	      { className: "docs-main" },
	      _react2.default.createElement(
	        "div",
	        {
	          className: "docs-breadcrumbs",
	          role: "navigation",
	          "aria-label": "breadcrumbs navigation"
	        },
	        _react2.default.createElement(
	          "ul",
	          { className: "wy-breadcrumbs" },
	          "{% block breadcrumbs %}",
	          _react2.default.createElement(
	            "li",
	            null,
	            _react2.default.createElement(
	              "a",
	              { href: "{{ pathto(master_doc) }}" },
	              "Docs"
	            ),
	            " \xBB"
	          ),
	          "{% for doc in parents %}",
	          _react2.default.createElement(
	            "li",
	            null,
	            _react2.default.createElement(
	              "a",
	              { href: "{{ doc.link|e }}" },
	              "{{ doc.title }}"
	            ),
	            " \xBB"
	          ),
	          "{% endfor %}",
	          _react2.default.createElement(
	            "li",
	            null,
	            "{{ title }}"
	          ),
	          "{% endblock %}"
	        )
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "documentwrapper" },
	        _react2.default.createElement(
	          "div",
	          { className: "bodywrapper" },
	          _react2.default.createElement(
	            "div",
	            { className: "body", role: "main" },
	            "{{ body }}",
	            _react2.default.createElement(
	              "div",
	              { className: "go-buttons" },
	              "{% if prev %}",
	              _react2.default.createElement(
	                "a",
	                { href: "{{ prev.link|e }}", className: "go-previous flat-button" },
	                "Previous: ",
	                "{{ prev.title|striptags|e }}"
	              ),
	              "{% endif %}{% if next %}",
	              _react2.default.createElement(
	                "a",
	                {
	                  href: "{{ next.link|e }}",
	                  className: "go-next flat-button primary"
	                },
	                "Next: ",
	                "{{ next.title|striptags|e }}"
	              ),
	              "{% endif %}"
	            )
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = Docs;
	module.exports = exports["default"];
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 105:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-docs-js-8f61c8eac84fa7605edc.js